import { render, staticRenderFns } from "./hazardousDirectory.vue?vue&type=template&id=f4c071b0&scoped=true"
import script from "./hazardousDirectory.vue?vue&type=script&lang=js"
export * from "./hazardousDirectory.vue?vue&type=script&lang=js"
import style0 from "./hazardousDirectory.vue?vue&type=style&index=0&id=f4c071b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c071b0",
  null
  
)

export default component.exports